import {
  SET_LEAD_FILTER_PARAMS,
  SET_LOG_FILTER_PARAMS,
  FILTERS_INIT_STATE,
  SET_COLUMN_FILTER_PARAMS,
  SET_TASK_LIST_FILTER_PARAMS,
  SET_TASK_GRAPH_FILTER_PARAMS,
  SET_PROPOSAL_LIST_FILTER_PARAMS,
  SET_KPI_LIST_FILTER_PARAMS,
  RESET_ALL_FILTERS,
} from "./types";

export const filtersReducer = (state = FILTERS_INIT_STATE, action) => {
  switch (action.type) {
    case SET_TASK_LIST_FILTER_PARAMS:
      return {
        ...state,
        taskListFilterParams: {
          ...state.proposalListFilterParams,
          ...action.payload,
        },
      };
    case SET_TASK_GRAPH_FILTER_PARAMS:
      return {
        ...state,
        taskGraphsFilterParams: {
          ...state.taskGraphsFilterParams,
          ...action.payload,
        },
      };
    case SET_PROPOSAL_LIST_FILTER_PARAMS:
      return {
        ...state,
        proposalListFilterParams: {
          ...state.proposalListFilterParams,
          ...action.payload,
        },
      };
    case SET_KPI_LIST_FILTER_PARAMS:
      return {
        ...state,
        kpiListFilterParams: {
          ...state.kpiListFilterParams,
          ...action.payload,
        },
      };
    case SET_LEAD_FILTER_PARAMS:
      return {
        ...state,
        leadFilter: action.params,
      };
    case SET_LOG_FILTER_PARAMS:
      return {
        ...state,
        logFilter: action.payload,
      };
    case SET_COLUMN_FILTER_PARAMS:
      return {
        ...state,
        columnFilter: action.payload,
      };
    case RESET_ALL_FILTERS:
      return FILTERS_INIT_STATE;
    default:
      return state;
  }
};
